import React, { useState, useEffect } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Suyooltosuyool.scss";
import SuyoulBulkTransferTemplate from "./BulkTransferTemplate";
import NewFreeTransferTemplate from "./NewFreeTransferTemplate";
import SuyooltoSuyoolTemplate from "./SuyooltoSuyoolTemplate";
import { useLocation } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {setFlag} from "../../features/responseSlice";

function Suyooltosuyool() {
    const {flag} = useSelector((state) => state.transferResponse);

    const [activeButton, setActiveButton] = useState({ name: "Suyool To Suyool" });
    const location = useLocation();
    const name = location.state?.name;

    const dispatch = useDispatch();

    const handleButtonClick = (event) => {
        setActiveButton({ name: event.target.innerText });
    };

    useEffect(() => {
        if (name !== undefined) {
            setActiveButton({ name: name })
        }
    }, []);

    useEffect(()=>{
        if([0, 1, 2].includes(flag)){
            dispatch(setFlag(null))
            setActiveButton({name:"Suyool To Suyool"});
        }
    }, [flag]);
    const EntityRole = sessionStorage.getItem("EntityRole");

    return (
        <>
            <HeaderComponent title="Suyool To Suyool" />
            <div className="SuyooltosuyoolPage">
                <div className="container-fluid SuyooltosuyoolPagecontainer">
                    <div className="row">
                        <div className="col-lg-10 col-sm-12 ">
                            <div className="top_section">
                                <button className={`navButton ${activeButton.name === "Suyool To Suyool" ? "active" : ""}`} onClick={handleButtonClick}>Suyool To Suyool</button>
                                {EntityRole!=="VIEWER" ? (
                                    <>
                                        <button className={`navButton ${activeButton.name === "+ New Free Transfer" ? "active" : ""}`} onClick={handleButtonClick}>+ New Free Transfer</button>
                                        <button className={`navButton ${activeButton.name === "+ Bulk Transfer" ? "active" : ""}`} onClick={handleButtonClick}>+ Bulk Transfer</button>
                                    </>
                                ) : (<></>)}
                            </div>
                        </div>
                        <div className="col-lg-2 col-sm-12"></div>
                    </div>

                    <div className="row">
                        {activeButton.name === "Suyool To Suyool" && <SuyooltoSuyoolTemplate setActiveButton={setActiveButton} />}
                        {EntityRole!=="VIEWER" ? (
                            <>
                                {activeButton.name === "+ New Free Transfer" && <NewFreeTransferTemplate setActiveButton={setActiveButton}/>}
                                {activeButton.name === "+ Bulk Transfer" && <SuyoulBulkTransferTemplate setActiveButton={setActiveButton}/>}
                            </>
                        ) : (<></>)}

                    </div>
                </div>
            </div>
        </>
    );
}
export default Suyooltosuyool;